import { Link } from "react-router-dom";
import { gkCategories } from "@/mocks/categories";
import NewsletterForm from "./NewsletterForm";

export default function Footer() {
  return (
    <footer className="border-t border-background-200 bg-background-100">
      {/* Subscribe band */}
      <div className="border-b border-background-200">
        <div className="mx-auto flex max-w-6xl flex-col items-center gap-6 px-4 py-12 md:px-8 lg:flex-row lg:justify-between">
          <div className="max-w-md text-center lg:text-left">
            <h2 className="font-heading text-2xl text-foreground-900">订阅每日瓜料，不落下一场热闹</h2>
            <p className="mt-2 text-sm text-foreground-600">留下邮箱，每日新瓜、最新爆料与新鲜瓜速递准时推送给你。</p>
          </div>
          <NewsletterForm />
        </div>
      </div>

      {/* Footer columns */}
      <div className="mx-auto grid max-w-6xl grid-cols-2 gap-8 px-4 py-12 md:px-8 lg:grid-cols-4">
        <div className="col-span-2 lg:col-span-1">
          <Link to="/" className="flex items-center gap-2" aria-label="看吃瓜首页">
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
              <i className="ri-water-flash-fill text-lg"></i>
            </span>
            <span className="font-heading text-2xl text-primary-600">看吃瓜</span>
          </Link>
          <p className="mt-4 text-sm leading-6 text-foreground-600">
            每日瓜料准时更新的娱乐资讯门户，盯紧全网热点，从最新爆料到新鲜瓜速递，第一时间为你端上今日新瓜。
          </p>
          <div className="mt-4 flex gap-2">
            {["ri-weibo-line", "ri-wechat-line", "ri-douban-line"].map((icon) => (
              <a key={icon} href="#/about" rel="nofollow" aria-label="看吃瓜社交平台" className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 ring-1 ring-background-200 text-foreground-600 transition-colors hover:text-primary-500">
                <i className={icon}></i>
              </a>
            ))}
          </div>
        </div>

        <div>
          <h3 className="text-sm font-semibold text-foreground-900">快速导航</h3>
          <ul className="mt-4 space-y-2 text-sm text-foreground-600">
            <li><Link to="/" className="hover:text-primary-600">今日新瓜</Link></li>
            <li><Link to="/news" className="hover:text-primary-600">新鲜瓜速递</Link></li>
            <li><Link to="/about" className="hover:text-primary-600">关于我们</Link></li>
            <li><Link to="/faq" className="hover:text-primary-600">常见问题</Link></li>
          </ul>
        </div>

        <div>
          <h3 className="text-sm font-semibold text-foreground-900">栏目瓜田</h3>
          <ul className="mt-4 grid grid-cols-1 gap-2 text-sm text-foreground-600 sm:grid-cols-2 lg:grid-cols-1">
            {gkCategories.map((c) => (
              <li key={c.slug}><Link to={`/category/${c.slug}`} className="hover:text-primary-600">{c.name}</Link></li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="text-sm font-semibold text-foreground-900">联系我们</h3>
          <ul className="mt-4 space-y-3 text-sm text-foreground-600">
            <li className="flex items-start gap-2"><i className="ri-mail-line mt-0.5 text-primary-500"></i><span>投稿 / 线索：tougao@kanchigua.example</span></li>
            <li className="flex items-start gap-2"><i className="ri-chat-3-line mt-0.5 text-primary-500"></i><span>合作：hello@kanchigua.example</span></li>
            <li className="flex items-start gap-2"><i className="ri-time-line mt-0.5 text-primary-500"></i><span>每日更新 · 周末热点加更</span></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-background-200 bg-background-100">
        <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-2 px-4 py-5 text-xs text-foreground-500 sm:flex-row md:px-8">
          <p>© 2026 看吃瓜 KanChiGua · 娱乐瓜料资讯门户</p>
          <p className="flex items-center gap-1"><i className="ri-copyright-line"></i>理性吃瓜，快乐冲浪。所有人物均为虚构，请勿对号入座。</p>
        </div>
      </div>
    </footer>
  );
}